"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "riva-del-po": {
    "65954556": [{
      "hkey": "e473ab1b",
      "slug": "ro-zocca",
      "name": "Ro-Zocca",
      "primary": true,
      "skipSearch": false
    }],
    "zocca": [{
      "hkey": "e473ab1b",
      "slug": "ro-zocca",
      "name": "Ro-Zocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "riva-del-po"
    }]
  }
};
exports["default"] = _default;